import { api } from './index';

// A shift's amounts: flat (price, caregiverCost) or, when the company charges
// per hour, hourly rates with their totals.
export type ShiftAmounts = {
  price: number | null;
  caregiverCost: number | null;
  withTaxBill: boolean | null;
  pricePerHour: number | null;
  caregiverCostPerHour: number | null;
}

export type ShiftRecalculationRow = {
  id: number;
  // When the shift last changed: applying refuses it if it changed meanwhile.
  updatedAt: string;
  humanDate: string;
  humanTime: string;
  hours: number;
  caregiverId: number;
  caregiverFullName: string;
  // Already charged with a tax document (DTE, a charge closure): its price stays as it is.
  chargeClosed: boolean;
  // Worked on a day a contract caregiver's salary covers: no pay or tax bill of its own.
  salaried: boolean;
  current: ShiftAmounts;
  recalculated: ShiftAmounts;
}

export type ShiftRecalculationPreview = {
  perHour: boolean;
  shifts: ShiftRecalculationRow[];
}

// "recalculate" takes the pricing in force; "special" saves the given amounts.
export type ShiftRecalculationChange = {
  id: number;
  updatedAt: string;
  mode: 'recalculate' | 'special';
  price?: number;
  caregiverCost?: number;
  pricePerHour?: number;
  caregiverCostPerHour?: number;
  withTaxBill?: boolean;
}

function basePath(patientId: number) {
  return `/api/internal/patients/${patientId}/shift_recalculations`;
}

export const shiftRecalculationsApi = {
  preview(patientId: number, from: string, to: string): Promise<ShiftRecalculationPreview> {
    return api({
      method: 'get',
      url: basePath(patientId),
      params: { from, to },
    }).then(response => response.data.shiftRecalculation);
  },
  apply(patientId: number, changes: ShiftRecalculationChange[]): Promise<{ updated: number }> {
    return api({
      method: 'post',
      url: basePath(patientId),
      data: { shiftRecalculation: { shifts: changes } },
    }).then(response => response.data.shiftRecalculation);
  },
};
